import { ID_SITE } from '@shared/conf/env';
import { setPageConfigurations } from '@shared/redux/actions';
import { getSiteInformation } from '@shared/services/services';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const usePalette = () => {
  const dispatch = useDispatch();
  const [site_colors, setSite_colors] = useState(null);

  const isDataLoaded = !!site_colors;

  useEffect(() => {
    getSiteInformation(Number(ID_SITE)).then(res => {
      dispatch(setPageConfigurations(res));
      setSite_colors(res.site_colors);
    });
  }, []);

  const palette = {
    primary: {
      dark: '#000',
      main: site_colors?.primary || '#000',
      light: '#000',
    },
    tertiary: {
      main: site_colors?.tertiary || '#182A5E',
      contrastText: site_colors?.colorText1,
    },
    secondary: {
      dark: '#ffffff',
      main: site_colors?.tertiary || '#600DFC',
      light: '#ffffff',
    },
    text: {
      textGray: '#5e5e5e',
      textWhite: '#ffffff',
      textSubtitle: '#000',
      colorText1: site_colors?.colorText1 || '#000',
      colorText2: site_colors?.colorText2 || '#000',
      darkGray: site_colors?.darkGray || 'gray',
    },
    extraColors: {
      red: '#EB5A46',
      headerColor: site_colors?.headerColor || '#182A5E',
      footerColor: site_colors?.footerColor || '#182A5E',
    },
  };

  return { palette, isDataLoaded };
};

export default usePalette;
